export default {
  Title: 'List of Requests',
  Domain: 'Domain',
  Types: 'Types',
  Source: 'Source',
  SaleRevenue: 'Sales Revenue',
  PartnerProceeds: 'Partner Proceeds',
  MisaProceeds: 'MISA Proceeds',
  Upgrade: 'Upgrade',
  Extend: 'Extend',
  PurchaseDevice: 'Purchase devices',
  NeedApproval: 'Need Approval',
  Rejected: 'Rejected',
  Approved: 'Approved',
  By: 'by ',
  Approve: 'Approve',
  Edit: 'Edit',
  Delete: 'Delete',
  Search: 'Search',
  Filter: 'Filter',
  Type: 'Type',
  PurchaseExtraDevices: 'Purchase extra devices',
  Status: 'Status',
  All: 'All',
  DateCreated: 'Created date',
  MerchantID: 'MID',
  Createby: 'Created by',
  Clear: 'Clear',
  Cancel: 'Cancel',
  Apply: 'Apply',
  Total: 'Total: {number} requests',
  TotalRange: 'requests',
  ApproveRequest: 'Approved Request',
  ApproveRequestText: 'Are you sure you want to approve this request?',
  Success: 'Update successfully',
  SuccessFail: 'Update failed',
  OtherReason: 'Orther reasons',
  AcceptDelete: 'Are you sure delete this request?',
  Failed: 'An error occurred, please try again',
  Partner: 'Partner',
  DeleteSuccess: 'Delete successfully',
  RequestNewBranch: 'New branch',
  UnknownType: 'Unknown type',
  NumberOfBranchPurchasing: 'Number of additional branches purchasing',
  BranchList: 'Branch list',
  BranchName: 'Branch name',
  BranchNameMaxLength: 'Branch name must be less than 100 characters',
  SelectPackage: 'Select package',
  STT: 'No.',
  Package: 'Package',
  BranchQuantityMustBeGreaterThan0: 'Branch quantity must be greater than 0',
  BranchQuantityMustBeLessThan50: 'Branch quantity must be less than 50',
  ConfirmCreateBranch: 'Are you sure you want to create these branches?',
  ConfirmUpgradeBranch: 'Are you sure you want to upgrade branches?',
  ConfirmExtendBranch: 'Are you sure you want to extend branches?',
  Save: 'Save',
  Confirm: 'Confirm',
  Cancel: 'Cancel',
  PleaseSelectPackageForBranch: 'Please select package for branch {branch_name}',
  CreationDate: 'Created date',
  StartDate: 'Start date',
  EndDate: 'End date',
  Status: 'Status',
  NumberOfPOS: 'Number of POS',
  NumberOfExtraPOS: 'Number of Extra POS',
  NumberOfExtraKiosk: 'Number of Extra Kiosk',
  NumberOfExtraTablet: 'Number of Extra Tablet/Handheld',
  OrderValue: 'Total',
  DeviceList: 'List of devices',
  SubscriptionHistory: 'Subscription history',
  Date: 'Date',
  Action: 'Action',
  NumberOfTablet: 'Number of Tablet/Handhelds',
  NumberOfKiosk: 'Number of Kiosk',
  Creator: 'Created by',
  Approver: 'Approved by',
  DeviceType: 'Device type',
  Quantity: 'Quantity',
  DeviceStartDate: 'Start date',
  DeviceEndDate: 'End date',
  // Chart translations
  TotalRevenue: 'Total revenue',
  PartnerPayout: 'Partner amount',
  NetRevenue: 'Net revenue',
  TotalLicenses: 'Total licenses',
  NewRegistration: 'New registration',
  NewActivation: 'New activation',
  NoData: 'No data',
  Loading: 'Loading...',
  RevenueTooltip: '{label}: {value}',
  LicenseTooltip: '{label}: {value}',
  // Time range options
  ThisMonth: 'This month',
  Today: 'Today',
  ThisWeek: 'This week',
  LastMonth: 'Last month',
  January: 'January',
  February: 'February',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'August',
  September: 'September',
  October: 'October',
  November: 'November',
  December: 'December',
  ThisQuarter: 'This quarter',
  LastQuarter: 'Last quarter',
  Quarter1: 'Quarter 1',
  Quarter2: 'Quarter 2',
  Quarter3: 'Quarter 3',
  Quarter4: 'Quarter 4',
  ThisYear: 'This year',
  LastYear: 'Last year',
  ComparedToPrevious: 'Compared to previous period',
  ComparedToSamePeriodLastYear: 'Compared to same period last year',
  // Dashboard KPI Headers
  NetRevenue: 'Net revenue',
  TotalLicenses: 'Total licenses',
  NewRegistration: 'New registration',
  SoftwareUsageRate: 'Software usage rate',
  NewActivation: 'New activation',
  LicenseActivationRate: 'License activation rate',
  LicensesAboutToExpire: 'Licenses about to expire',
  RenewalRate: 'Renewal rate',
  // Component Titles
  ExtraDevicesAddOnFeatures: 'Extra devices/Add-on features',
  LicensesByPackage: 'Licenses by Package',
  NetRevenueByPartner: 'Net revenue by partner',
  RevenueBySalesperson: 'Revenue by salesperson',
  // Table Headers
  Partner: 'Partner',
  Country: 'Country',
  NewLicensesThis: 'New licenses (This)',
  NewlyActivatedLicenses: 'Newly activated licenses',
  ActivatedRate: 'Activated rate',
  ExpiringLicenses: 'Expiring licenses',
  RenewedLicenses: 'Renewed licenses',
  RenewalRateTable: 'Renewal rate',
  SoftwareUsageRateTable: 'Software usage rate',
  Revenue: 'Revenue',
  Salesperson: 'Salesperson',
  SearchPartner: 'Search partner...',
  // General
  All: 'All',
  AllPartners: 'All Partners',
  // Messages
  NoPartnerData: 'No partner data available',
  NoPartnersMatch: 'No partners match your search',
  NoRevenueData: 'No revenue data available',
  NoDataAvailable: 'No data available',
  
  // Tooltip messages
  SoftwareUsageRateTooltip: 'Active domains / Total domains',
  LicenseActivationTooltip: '{activated}/{total} domain activated',
  RenewalRateTooltip: '{renewed}/{total} domain extended',
  IncludePackage: 'Include package',
  Extra: 'Extra'
};